import createIcon from '../../createIcon';

/**
 * @component @name SetMeal
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuMDUgMTcuNTY5OEwzLjA4IDE4LjUwOThMMyAxNy4wMDk4TDIwLjk4IDE2LjA2OThMMjEuMDUgMTcuNTY5OFpNMjEgMTkuNDg5OEgzVjIwLjk4OThIMjFWMTkuNDg5OFpNMjIgNS4wMDk3N1YxMi4wMDk4QzIyIDEzLjEwOTggMjEuMSAxNC4wMDk4IDIwIDE0LjAwOThINEMyLjkgMTQuMDA5OCAyIDEzLjEwOTggMiAxMi4wMDk4VjUuMDA5NzdDMiAzLjkwOTc3IDIuOSAzLjAwOTc3IDQgMy4wMDk3N0gyMEMyMS4xIDMuMDA5NzcgMjIgMy45MDk3NyAyMiA1LjAwOTc3Wk0yMCA2LjAwOTc3QzE4LjMyIDYuMDA5NzcgMTYuOTYgNi45ODk3NyAxNi43OSA4LjIzOTc3QzE2LjE1IDcuNTA5NzcgMTQuMDYgNS41MDk3NyAxMC4yNSA1LjUwOTc3QzUuNTggNS41MDk3NyAzLjUgOC41MDk3NyAzLjUgOC41MDk3N0MzLjUgOC41MDk3NyA1LjU4IDExLjUwOTggMTAuMjUgMTEuNTA5OEMxNC4wNiAxMS41MDk4IDE2LjE1IDkuNTA5NzcgMTYuNzkgOC43Nzk3N0MxNi45NiAxMC4wMjk4IDE4LjMyIDExLjAwOTggMjAgMTEuMDA5OFY2LjAwOTc3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SetMeal = createIcon('SetMeal', [
  [
    'path',
    {
      d: 'M21.05 17.5698L3.08 18.5098L3 17.0098L20.98 16.0698L21.05 17.5698ZM21 19.4898H3V20.9898H21V19.4898ZM22 5.00977V12.0098C22 13.1098 21.1 14.0098 20 14.0098H4C2.9 14.0098 2 13.1098 2 12.0098V5.00977C2 3.90977 2.9 3.00977 4 3.00977H20C21.1 3.00977 22 3.90977 22 5.00977ZM20 6.00977C18.32 6.00977 16.96 6.98977 16.79 8.23977C16.15 7.50977 14.06 5.50977 10.25 5.50977C5.58 5.50977 3.5 8.50977 3.5 8.50977C3.5 8.50977 5.58 11.5098 10.25 11.5098C14.06 11.5098 16.15 9.50977 16.79 8.77977C16.96 10.0298 18.32 11.0098 20 11.0098V6.00977Z',
      key: '1fuo66',
    },
  ],
]);

export default SetMeal;
